"use client";

import "@offstreetparking/design-system/styles/theme.css";
import { captureException } from "@offstreetparking/instrumentation/client";
import { useEffect, useState } from "react";
import { UnhandledRunTimeError } from "~/components/feedback/UnhandledRunTimeError";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
	const [eventId, setEventId] = useState<string | null>(null);
	useEffect(() => {
		setEventId(captureException(error) ?? null);
	}, [error]);

	return (
		<html lang="en">
			<body>
				<div className="flex h-screen items-center justify-center">
					<UnhandledRunTimeError eventId={eventId} error={error} onReload={reset} />
				</div>
			</body>
		</html>
	);
}
